import API from 'api/hallomart';

/**
 * Constants
 */

export const REQUEST_FUNDS = 'requestFunds/REQUEST_FUNDS';
export const REQUEST_FUNDS_OK = 'requestFunds/REQUEST_FUNDS_OK';
export const REQUEST_FUNDS_FAILED = 'requestFunds/REQUEST_FUNDS_FAILED';


/**
 * Action Creators
 */

export function requestFundsPayout(amount = 0) {
	return async (dispatch) => {
		try {
			dispatch({ type: REQUEST_FUNDS });
			const data = await API.requestFundsPayout(amount);
			dispatch({ type: REQUEST_FUNDS_OK, payload: data.data });
		} catch (err) {
			dispatch({ type: REQUEST_FUNDS_FAILED, error: err.response || err.message });
		}
	};
}


/**
 * Reducers
 */

const initialState = {
	isLoading: false,
	isSuccess: false,
	error: false,
	errors: {}
};

export default function requestFunds(state = initialState, action) {
	switch (action.type) {
		case REQUEST_FUNDS:
			return {
				error: false,
				errors: {},
				isLoading: true,
				isSuccess: false
			};

		case REQUEST_FUNDS_OK:
			return {
				...state,
				isLoading: false,
				isSuccess: true
			};

		case REQUEST_FUNDS_FAILED:
			return {
				error: true,
				errors: action.error,
				isLoading: false,
				isSuccess: false
			};

		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/modules/requestFunds.js